import React, { useState } from 'react';

import { useNavigation } from '../../../common/navigation';
import ValidationAlert from '../ValidationAlert';

import { ResetPassword } from './ResetPassword';

export type Props = {
  onResetPassword: (email: string) => void;
};

export const ResetPasswordDialog: React.FC<Props> = ({ onResetPassword }) => {
  const nav = useNavigation();
  const [showError, setShowError] = useState(false);
  const [errorText, setErrorText] = useState('');
  const [showConfirmation, setShowConfirmation] = useState(false);

  const handleResetPassword = async (email: string) => {
    try {
      await onResetPassword(email);
      setShowConfirmation(true);
    } catch (err) {
      setErrorText('Błąd podczas resetu hasła: ' + (err as Error).message);
      setShowError(true);
    }
  };

  return (
    <>
      <ValidationAlert
        heading={'RESET HASŁA'}
        variant={'warning'}
        show={showError}
        modal={true}
        onHide={() => {
          setShowError(false);
        }}
        errors={[errorText]}
      />

      <ValidationAlert
        heading={'Sprawdź skrzynkę e-mail'}
        variant={'info'}
        show={showConfirmation}
        modal={true}
        onHide={() => {
          setShowConfirmation(false);
          void nav.login();
        }}
        errors={[
          'Jeśli podany adres e-mail jest zarejestrowany w systemie, otrzymasz na niego wiadomość z linkiem do zresetowania hasła. Sprawdź skrzynkę odbiorczą oraz folder SPAM. Jeśli wiadomość nie dotrze, upewnij się, że adres e-mail został wpisany poprawnie.',
        ]}
      />

      <ResetPassword onResetPassword={handleResetPassword} />
    </>
  );
};
